import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import { getCountryCallingCode } from 'libphonenumber-js';
import { Icon } from '@haldor/ui';
import './_phoneInput.scss';

var PhoneInput = function PhoneInput(_ref) {
  var _input$value;

  var placeholder = _ref.placeholder,
      disabled = _ref.disabled,
      input = _ref.input,
      meta = _ref.meta,
      countryCode = _ref.countryCode;
  var defaultValue = (_input$value = input === null || input === void 0 ? void 0 : input.value) !== null && _input$value !== void 0 ? _input$value : '';

  if (defaultValue.length > 0) {
    defaultValue = defaultValue.replace('+', '');
  }

  var _useState = useState(defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  useEffect(function () {
    if (input != null && input.onChange != null) {
      input.onChange(value);
    }
  }, [value]);

  var onInputFocus = function onInputFocus() {
    if (value == '') {
      if (countryCode != null) {
        setValue(getCountryCallingCode(countryCode));
      } else {
        setValue('46');
      }
    }
  };

  var clearInput = function clearInput() {
    setValue('');
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "input--phone"
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-container"
  }, /*#__PURE__*/React.createElement("span", null, "+"), /*#__PURE__*/React.createElement("input", _extends({
    type: "text",
    placeholder: placeholder,
    style: meta.touched && meta.error ? {
      border: '1px solid red'
    } : {},
    disabled: disabled
  }, input, {
    value: value,
    onChange: function onChange(event) {
      return setValue(event.target.value);
    },
    onFocus: onInputFocus
  })), value != '' ? /*#__PURE__*/React.createElement("div", {
    className: "clear-button",
    onClick: clearInput
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "Close"
  })) : null), meta.touched && (meta.error && /*#__PURE__*/React.createElement("span", {
    style: {
      marginTop: '1rem',
      color: 'red'
    }
  }, meta.error) || meta.warning && /*#__PURE__*/React.createElement("span", {
    style: {
      marginTop: '1rem',
      color: 'red'
    }
  }, meta.warning)));
};

export default PhoneInput;